import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import LoginPage from "../Login/LoginPage";
import Dashboard from "../Dashboard/DashboardPage";
import AdminUsers from "../CcpAdmin/CcpAdminUsers/CcpAdminUsers";
import FAQs from "../CcpAdmin/CcpAdminFaqs/CcpAdminFaqs";
import CcpAdminAnnouncements from "../CcpAdmin/CcpAdminAnnouncements/CcpAdminAnnouncements";
import SchoolUsers from "../SchoolUsers/SchoolUsers";
import CcpAdminArchivedData from "../CcpAdmin/CcpAdminArchivedData/CcpAdminArchivedData";
import CcpAdminDistricts from "../CcpAdmin/CcpAdminDistricts/CcpAdminDistricts";
import CcpAdminForms from "../CcpAdmin/CcpAdminForms/CcpAdminForms";
import CcpAdminNewCourseRequest from "../CcpAdmin/CcpAdminNewCourseRequest/CcpAdminNewCourseRequest";
import CcpAdminChangeCourseRequest from "../CcpAdmin/CcpAdminChangeCourseRequest/CcpAdminChangeCourseRequest";
import CcpAdminPortalContent from "../CcpAdmin/CcpAdminPortalContent/CcpAdminPortalContent";
import CcpAdminSchools from "../CcpAdmin/CcpAdminSchools/CcpAdminSchools";
import CcpSchoolAccountProfile from "../CcpSchool/CcpSchoolAccountProfile/CcpSchoolAccountProfile";
import CcpSchoolAppsAndTesting from "../CcpSchool/CcpSchoolAppsAndTesting/CcpSchoolAppsAndTesting";
import CcpSchoolReports from "../CcpSchool/CcpSchoolReports/CcpSchoolReports";
import CcpSchoolRestrictedCourses from "../CcpSchool/CcpSchoolRestrictedCourses/CcpSchoolRestrictedCourses";
import CcpSchoolCoursePlanning from "../CcpSchool/CcpSchoolRestrictedCourses/CcpSchoolCoursePlanning";
import CcpSchoolHelp from "../CcpSchool/CcpSchoolHelp/CcpSchoolHelp";
import CcpStatsAndTrends from "../CcpSchool/CcpStatsAndTrends/CcpStatsAndTrends";
import CcpStudentInfo from "../CcpSchool/CcpStudentInfo/CcpStudentInfo";
import CcpAdminResources from "../CcpAdmin/CcpAdminResources/CcpAdminResources";
import CcpAdminSchoolView from "../CcpAdmin/CcpAdminSchoolView/CcpAdminSchoolView";
import TechPrepAdminRoutes from "./TechPrepAdminRoutes";
import ProtectedRoute from "../../config/ProtectedRoute";
import SuperSchoolUsersMgt from "../SuperAdmin/SuperSchoolUsersMgt";
import CrudTest from "../CrudTest/CrudTest";
import DbUpdates from "../DbUpdates/DbUpdates";
import TpCreditCapture from "../TpPortalMgt/CreditCapture/CreditCapture";
import CcpAdminCoursePlanning from "../CcpAdmin/CcpAdminCoursePlanning/CcpAdminCoursePlanning";
import CcpAdminTerm from "../CcpAdmin/CcpAdminTerm/CcpAdminTerm";
import CcpAdminHsTerm from "../CcpAdmin/CcpAdminHsTerms/CcpAdminHsTerm";
import TechPrepShowcaseForm from "../TpShowCase/TechPrepShowcaseForm";
import TechPrepShowcaseFormB from "../TpShowCase/TechPrepShowcaseFormB";
import TechPrepShowcaseFormC from "../TpShowCase/TechPrepShowcaseFormC";
import CcpAdminCourses from "../CcpAdmin/CcpAdminCourseMgt/CcpAdminCourses";
import CcpAdminInstructors from "../CcpAdmin/CcpAdminInstructors/CcpAdminInstructors";
import CcpAdminModality from "../CcpAdmin/CcpAdminModality/CcpAdminModality";
import CcpAdminInstructorType from "../CcpAdmin/CcpAdminInstructorType/CcpAdminInstructorType";
import CcpAdminProctors from "../CcpAdmin/CcpAdminProctors/CcpAdminProctors";
import CcpAdminBuildingMgt from "../CcpAdmin/CcpAdminBuildingMgt/CcpAdminBuildingMgt";
import CourseEntriesAdmin from "../CcpAdmin/CcpAdminCoursesEntries/CourseEntriesAdmin";
import Xcsi from "../CcpAdmin/CcpAdminXcsi/Xcsi";
import CoursePlanningFormEntries from "../CcpAdmin/CcpAdminCoursePlanning/inc/CoursePlanningFormEntries";
import CcpAdminCoursePlanningBetaTesting from "../CcpAdmin/CcpAdminCoursePlanning/CcpAdminCoursePlanningBetaTesting";
import CcpAdminSchoolFeedback from "../CcpAdmin/CcpAdminSchoolFeedback/CcpAdminSchoolFeedback";

const MainRoutes = () => {
  return (
    <Routes>
      <Route path="/" element={<Navigate to="/login" />} />
      <Route path="/login" element={<LoginPage />} />
      <Route path="/tech-prep-showcase" element={<TechPrepShowcaseForm />} />
      <Route
        path="/tech-prep-showcase-form-b/:showcaseId"
        element={<TechPrepShowcaseFormB />}
      />
      <Route
        path="/tech-prep-showcase-form-c/:showcaseId"
        element={<TechPrepShowcaseFormC />}
      />
      <Route
        path="/Dashboard"
        element={
          <ProtectedRoute>
            <Dashboard />
          </ProtectedRoute>
        }
      />
      <Route
        path="/Admin-users"
        element={
          <ProtectedRoute>
            <AdminUsers />
          </ProtectedRoute>
        }
      />
      <Route
        path="/CrudTest"
        element={
          <ProtectedRoute>
            <CrudTest />
          </ProtectedRoute>
        }
      />
      <Route
        path="/DbUpdates"
        element={
          <ProtectedRoute>
            <DbUpdates />
          </ProtectedRoute>
        }
      />
      <Route
        path="/CcpAdminCoursePlanning"
        element={
          <ProtectedRoute>
            <CcpAdminCoursePlanning />
          </ProtectedRoute>
        }
      />
      <Route
        path="/CcpAdminTerm"
        element={
          <ProtectedRoute>
            <CcpAdminTerm />
          </ProtectedRoute>
        }
      />
      <Route
        path="/CcpAdminHsTerm"
        element={
          <ProtectedRoute>
            <CcpAdminHsTerm />
          </ProtectedRoute>
        }
      />
      <Route
        path="/TpCreditCapture"
        element={
          <ProtectedRoute areaKey="TpCreditCapture">
            <TpCreditCapture />
          </ProtectedRoute>
        }
      />
      <Route
        path="/SuperSchoolUsersMgt"
        element={
          <ProtectedRoute>
            <SuperSchoolUsersMgt />
          </ProtectedRoute>
        }
      />
      <Route
        path="/SchoolUsers"
        element={
          <ProtectedRoute>
            <SchoolUsers />
          </ProtectedRoute>
        }
      />
      <Route
        path="/Faqs"
        element={
          <ProtectedRoute>
            <FAQs />
          </ProtectedRoute>
        }
      />
      <Route
        path="/CcpAdminAnnouncements"
        element={
          <ProtectedRoute>
            <CcpAdminAnnouncements />
          </ProtectedRoute>
        }
      />
      <Route
        path="/CcpAdminArchivedData"
        element={
          <ProtectedRoute>
            <CcpAdminArchivedData />
          </ProtectedRoute>
        }
      />
      <Route
        path="/CcpAdminDistricts"
        element={
          <ProtectedRoute>
            <CcpAdminDistricts />
          </ProtectedRoute>
        }
      />
      <Route
        path="/CcpAdminForms"
        element={
          <ProtectedRoute>
            <CcpAdminForms />
          </ProtectedRoute>
        }
      />
      <Route
        path="/CcpAdminNewCourseRequest"
        element={
          <ProtectedRoute>
            <CcpAdminNewCourseRequest />
          </ProtectedRoute>
        }
      />
      <Route
        path="/CcpAdminChangeCourseRequest"
        element={
          <ProtectedRoute>
            <CcpAdminChangeCourseRequest />
          </ProtectedRoute>
        }
      />
      <Route
        path="/CcpAdminPortalContent"
        element={
          <ProtectedRoute>
            <CcpAdminPortalContent />
          </ProtectedRoute>
        }
      />
      <Route
        path="/CcpAdminSchools"
        element={
          <ProtectedRoute>
            <CcpAdminSchools />
          </ProtectedRoute>
        }
      />
      <Route
        path="/CcpSchoolAccountProfile"
        element={
          <ProtectedRoute>
            <CcpSchoolAccountProfile />
          </ProtectedRoute>
        }
      />
      <Route
        path="/CcpSchoolAppsAndTesting"
        element={
          <ProtectedRoute>
            <CcpSchoolAppsAndTesting />
          </ProtectedRoute>
        }
      />
      <Route
        path="/CcpSchoolReports"
        element={
          <ProtectedRoute>
            <CcpSchoolReports />
          </ProtectedRoute>
        }
      />
      <Route
        path="/CcpSchoolRestrictedCourses"
        element={
          <ProtectedRoute>
            <CcpSchoolRestrictedCourses />
          </ProtectedRoute>
        }
      />
      <Route
        path="/CcpSchoolCoursePlanning"
        element={
          <ProtectedRoute>
            <CcpSchoolCoursePlanning />
          </ProtectedRoute>
        }
      />
      <Route
        path="/CcpSchoolHelp"
        element={
          <ProtectedRoute>
            <CcpSchoolHelp />
          </ProtectedRoute>
        }
      />
      <Route
        path="/CcpStudentInfo"
        element={
          <ProtectedRoute>
            <CcpStudentInfo />
          </ProtectedRoute>
        }
      />
      <Route
        path="/CcpStatsAndTrends"
        element={
          <ProtectedRoute>
            <CcpStatsAndTrends />
          </ProtectedRoute>
        }
      />
      <Route
        path="/CcpAdminResources"
        element={
          <ProtectedRoute>
            <CcpAdminResources />
          </ProtectedRoute>
        }
      />
      <Route
        path="/CcpAdminSchoolView"
        element={
          <ProtectedRoute>
            <CcpAdminSchoolView />
          </ProtectedRoute>
        }
      />
      <Route
        path="/CcpAdminCourses"
        element={
          <ProtectedRoute>
            <CcpAdminCourses />
          </ProtectedRoute>
        }
      />
      <Route
        path="/CcpAdminInstructors"
        element={
          <ProtectedRoute>
            <CcpAdminInstructors />
          </ProtectedRoute>
        }
      />
      <Route
        path="/CcpAdminModality"
        element={
          <ProtectedRoute>
            <CcpAdminModality />
          </ProtectedRoute>
        }
      />
      <Route
        path="/CcpAdminInstructorType"
        element={
          <ProtectedRoute>
            <CcpAdminInstructorType />
          </ProtectedRoute>
        }
      />
      <Route
        path="/CcpAdminProctors"
        element={
          <ProtectedRoute>
            <CcpAdminProctors />
          </ProtectedRoute>
        }
      />
      <Route
        path="/CcpAdminBuildingMgt"
        element={
          <ProtectedRoute>
            <CcpAdminBuildingMgt />
          </ProtectedRoute>
        }
      />
      <Route
        path="/admin/course-entries"
        element={
          <ProtectedRoute>
            <CourseEntriesAdmin />
          </ProtectedRoute>
        }
      />
      <Route
        path="/CcpAdminXcsi"
        element={
          <ProtectedRoute>
            <Xcsi />
          </ProtectedRoute>
        }
      />
      <Route
        path="/CcpAdminCoursePlanningEntries"
        element={
          <ProtectedRoute>
            <CoursePlanningFormEntries />
          </ProtectedRoute>
        }
      />
      <Route
        path="/CcpAdminCoursePlanningBetaTesting"
        element={
          <ProtectedRoute>
            <CcpAdminCoursePlanningBetaTesting />
          </ProtectedRoute>
        }
      />
      <Route
        path="/CcpAdminSchoolFeedback"
        element={
          <ProtectedRoute>
            <CcpAdminSchoolFeedback />
          </ProtectedRoute>
        }
      />
      <Route path="/*" element={<TechPrepAdminRoutes />} />
    </Routes>
  );
};

export default MainRoutes;
